import { type MessageId, type TurnId } from "@cmmd-forge/contracts";
import { type TurnDiffSummary } from "../../types";

/**
 * Stable default for MessagesTimeline's optional async callbacks.
 *
 * An inline `async () => undefined` default is a NEW function on every render,
 * so a memoised child sees a changed prop and re-renders even when nothing it
 * displays has changed.
 */
export const NO_OP_ASYNC = async (): Promise<undefined> => undefined;

const byRecency = (left: TurnDiffSummary, right: TurnDiffSummary) =>
  (left.checkpointTurnCount ?? -1) - (right.checkpointTurnCount ?? -1) ||
  left.completedAt.localeCompare(right.completedAt);

export function resolveLatestTurnDiffId(
  summaries: ReadonlyMap<MessageId, TurnDiffSummary>,
): TurnId | null {
  return Array.from(summaries.values()).toSorted(byRecency).at(-1)?.turnId ?? null;
}
